import PropTypes from 'prop-types'
import React from 'react'

class AuthContent extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired
  }

  render() {
    return (
      <div className="maha-auth-slide-content">
        {this.props.children}
      </div>
    )
  }

}

export default AuthContent
